import { Chakra } from "@airhelp/react-ui-components";
import { useTranslations } from "contexts/LocalizationContext";
import { useState } from "react";
import { CalendarIcon } from "styles/icons";
import options from "./config";
import type { OptionValue } from "./config.d";
import getBySeason from "./utility";
import type { SelectDateProps } from "./SelectDate.d";

const { Select } = Chakra;

const SelectDate = ({ updateTableContent }: SelectDateProps) => {
  const [defaultOption] = options;
  const [activeOption, setActiveOption] = useState<OptionValue>(defaultOption.value);
  const translations = useTranslations();

  const handleOnChange = async ({ target: { value } }) => {
    setActiveOption(value as OptionValue);
    const content = await getBySeason(value);
    updateTableContent(content);
  };

  return (
    <Select
      h="48px"
      bg="white"
      w={{ base: "full", md: 60 }}
      icon={<CalendarIcon />}
      onChange={handleOnChange}
      border="1px"
      borderColor="greyscale.400"
      defaultValue={activeOption}
    >
      {options.map(({ value, label: { season, year } }) => (
        <option key={value} value={value}>
          {translations(season)}&nbsp;{year}
        </option>
      ))}
    </Select>
  );
};

export default SelectDate;
